import { createContext, useContext } from 'react';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';

export const VerticalModeContext = createContext(false);

const useVerticalModeNew = () => {
	const context = useContext(VerticalModeContext);
	return context;
};

export const useVerticalMode = functionWithCondition(
	() => fg('list_lovability_improving_filters'),
	useVerticalModeNew,
	() => false,
);
